import { Component, OnInit } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CustomerStatusChecklistDialog } from '../customer-status-checklist/customer-status-checklist-old.component';
import { SalesCycleCheckListDialog } from '../sales-cycle-checklist/sales-cycle-checklist.component';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { Employee, SearchCRMFollowUp } from '../../models/models';

@Component({
    selector: 'crm-follow-ups',
    templateUrl: './crm-follow-ups.component.html',
    standalone: false
})
export class CrmFollowUps implements OnInit {
    private repType: string = '';
    private employeeId: number = 0;
    private filter: string = '';
    private originalFollowUp: SearchCRMFollowUp = {} as SearchCRMFollowUp;
    private originalAssignedToEmployeeId: number = 0;

    public followUps: SearchCRMFollowUp[] = [];
    public view: GridDataResult = { data: [], total: 0 };
    public state: State = { skip: 0, take: 10 };
    public employees: Employee[] = [];
    public pageSizes: number[] = [5, 10, 20, 50, 100, 200, 500];

    constructor(private crmService: CRMService, public dialog: MatDialog, private route: ActivatedRoute, private employeeService: EmployeeService) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.repType = params.repType;
            this.employeeId = params.employeeId;
            this.filter = params.filter;

            this.getFollowUps();
        });

        this.getEmployees();
    }

    getFollowUps() {
        if (this.crmService.followUps.length > 0) {
            this.followUps = this.crmService.followUps;
            this.filterFollowUps();
        } else {
            this.crmService.getSearchCRMFollowUpByEmployeeID(this.employeeId).subscribe(result => {
                this.followUps = result.resultCollection;
                this.filterFollowUps();
            });
        }        
    }

    filterFollowUps() {
        var beginToday = new Date();
        var endToday = new Date();
        var lastSunday = new Date();
        var nextSunday = new Date();

        beginToday.setHours(0, 0, 0, 0);
        endToday.setHours(23, 59, 59, 999);
        lastSunday.setDate(lastSunday.getDate() - lastSunday.getDay());
        lastSunday.setHours(0, 0, 0, 0);
        nextSunday.setDate(beginToday.getDate() + (7 + 0 - beginToday.getDay()) % 7);
        nextSunday.setHours(23, 59, 59, 999);

        this.followUps.forEach(a => {
            a.followUpDate = new Date(a.followUpDate);
        });

        //if (this.employeeId > 0) {
        //    this.followUps = this.followUps.filter(f => f.assignedToEmployeeID == this.employeeId);
        //}

        switch (this.filter) {
            case 'past-due':
                this.followUps = this.followUps.filter(f => f.followUpDate < beginToday);
                break;
            case 'today':
                this.followUps = this.followUps.filter(f => f.followUpDate > beginToday && f.followUpDate < endToday);
                break;
            case 'coming-due':
                this.followUps = this.followUps.filter(f => f.followUpDate > endToday  && f.followUpDate < nextSunday);
                break;
        }

        this.setFollowUpsGrid();
    }

    getEmployees() {
        this.employeeService.getActiveEmployees().subscribe(result => {
            this.employees = result;
        });
    }

    setFollowUpsGrid() {
        if (this.state.sort) {
            this.followUps = orderBy(this.followUps, this.state.sort);
        }

        this.view = process(this.followUps, this.state);
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.setFollowUpsGrid();
    }

    public getEmployeeName(employeeId: number): string {
        var employee = this.employees.find(e => e.employeeId == employeeId);

        if (employee == null) return '';

        return employee.fullName;
    }

    public openCustomerStatusDialog(customerId, customerStatusId, customerActionId) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            customerId: customerId,
            customerStatusId: customerStatusId,
            customerActionId: customerActionId
        }

        const dialogRef = this.dialog.open(CustomerStatusChecklistDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            this.getFollowUps();
        });
    }

    public openSalesCycleDialog(oppSalesCycleMapId, customerActionId) {
        this.crmService.getOpportunitySalesCylceMapById(oppSalesCycleMapId).subscribe(result => {
            if (result == null) return;

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            dialogConfig.data = {
                opportunitySalesCycleMap: result,
                customerActionId: customerActionId
            }

            const dialogRef = this.dialog.open(SalesCycleCheckListDialog, dialogConfig);

            dialogRef.afterClosed().subscribe(dialogResult => {
                this.getFollowUps();
            });
        });
    }

    public repSet(followUp: SearchCRMFollowUp, newRepId: number) {
        if (this.originalAssignedToEmployeeId == followUp.assignedToEmployeeID) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Test',
            message: 'Would you like to set all follow ups for this employee?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
                this.crmService.switchAssignedToReps(this.originalAssignedToEmployeeId, newRepId).subscribe(result => {
                    var ok = result;
                });
            }
        });
    }

    public repChanged(followUp: SearchCRMFollowUp, test) {
        if (this.originalFollowUp.customerActionID != null && this.originalFollowUp.customerActionID == followUp.customerActionID) return;

        this.originalFollowUp = followUp;
        this.originalAssignedToEmployeeId = followUp.assignedToEmployeeID;
    }
}
